import { render, staticRenderFns } from "./PersonCenter.vue?vue&type=template&id=6299efd0&scoped=true"
import script from "./PersonCenter.vue?vue&type=script&lang=js"
export * from "./PersonCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6299efd0",
  null
  
)

export default component.exports